import { Typography, Ul } from '@vp/swan';
import { useUserFeatureContext } from '@vp/core-ui-components';
import { DebugFeatureControls } from './DebugFeatureControls';
import { DebugNewFeatureEntry } from './DebugNewFeatureEntry';

export const DebugFeaturePanel = () => {
  const { activeFeatures } = useUserFeatureContext();

  if (!activeFeatures || activeFeatures.length < 1) {
    return (
      <div>
        <Typography> It appears you have no active features.</Typography>
        <DebugNewFeatureEntry />
      </div>
    );
  }

  return (
    <>
      <Typography fontWeight="bold" fontSize="small" mb={3}>
        Toggle Supported Features:
      </Typography>
      <Ul skin="minimal" mb={5}>
        {activeFeatures.map((activeFeature, index) => (
          <DebugFeatureControls
            featureName={activeFeature.featureName}
            enabled={activeFeature.enabled}
            key={index}
          />
        ))}
      </Ul>
      <DebugNewFeatureEntry />
    </>
  );
};
